import { render, staticRenderFns } from "./InvestorList.vue?vue&type=template&id=301153d4&"
import script from "./InvestorList.vue?vue&type=script&lang=js&"
export * from "./InvestorList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Volumes/Work/Work/gerocare/CrmWeb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports